import { client } from '../client';

export const markLastReadMessage = async (conversationSid: string, messageSid: string): Promise<void> => {
  const { data } = await client.patch(`/conversations/${conversationSid}/messages/${messageSid}/read`);

  return data;
};
